var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconMusic = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 64 64"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon-music_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 161159",
  fill: "none",
  d: "M0 0h64v64H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 31318",
  clipPath: "url(#icon-music_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38610",
  d: "M54.857 32A22.857 22.857 0 1132 9.143 22.857 22.857 0 0154.857 32",
  fill: "#f9a23a"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38611",
  d: "M38.263 43.823c.451 3.337-2.391 6.476-6.348 7.01s-7.53-1.737-7.981-5.073 2.391-6.476 6.348-7.011 7.53 1.737 7.981 5.074",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38612",
  d: "M37.685 15.801l.066 8.782 13.478 4.752v-8.714z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38613",
  d: "M30.682 51.724a7.936 7.936 0 01-4.2-1.164 6.074 6.074 0 01-2.914-4.273c-.528-3.555 2.381-6.944 6.486-7.554a8.282 8.282 0 014.984.781c.063.033.939.5 1.827 1.1V15.801a.824.824 0 011.1-.777l13.544 4.82a.824.824 0 01.548.777v8.714a.824.824 0 01-1.1.777l-12.443-4.388v18.468c0 4.045-2.445 6.824-6.541 7.433a8.777 8.777 0 01-1.291.099zm.651-11.437a7.063 7.063 0 00-1.036.077c-3.205.477-5.492 3.025-5.1 5.681a4.453 4.453 0 002.154 3.115 6.475 6.475 0 004.377.837c3.263-.486 5.135-2.6 5.135-5.8v-1.533a16.92 16.92 0 00-2.592-1.693 6.427 6.427 0 00-2.938-.687zm7.181-16.308l11.9 4.194v-6.97l-11.9-4.234z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 1440",
  d: "M32.035 20.148H16.917v-1.649h15.118z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38614",
  d: "M13.959 19.324a.6.6 0 11-.6-.6.594.594 0 01.6.6",
  fill: "#475257"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38615",
  d: "M13.363 20.876a1.552 1.552 0 111.552-1.552 1.554 1.554 0 01-1.552 1.552z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 1441",
  d: "M32.035 33.955H16.917v-1.649h15.118z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38616",
  d: "M13.959 33.13a.6.6 0 11-.6-.6.594.594 0 01.6.6",
  fill: "#475257"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38617",
  d: "M13.363 34.683a1.553 1.553 0 111.552-1.552 1.554 1.554 0 01-1.552 1.552z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 1442",
  d: "M32.035 27.051H16.917v-1.649h15.118z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38618",
  d: "M13.959 26.227a.6.6 0 11-.6-.6.594.594 0 01.6.6",
  fill: "#475257"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38619",
  d: "M13.363 27.779a1.553 1.553 0 111.552-1.552 1.554 1.554 0 01-1.552 1.552z",
  fill: "#29398c"
}))));
export default __webpack_public_path__ + "static/icon-music.7beb5d929a1c1fc63a1f87e7bc3c912e.svg";
export { SvgIconMusic as ReactComponent };